import { DropZone, DropZoneConfig, DropZoneType, TiledDropZone } from "src/games/shared/dropzone/DropZone";
import DropZoneSprite from "src/games/shared/dropzone/DropZoneSprite";
import { PhaserGeneralGameObjectType, TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";

class ScoreObject {
    public id: string;
    public display: string;
    public score: number;
}

export class MainScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    background: Phaser.GameObjects.Image;
    map: Phaser.Tilemaps.Tilemap;
    scores: ScoreObject[] = [];
    scoreTiles: Phaser.GameObjects.Text[] = [];
    bubbleText: Phaser.GameObjects.Text;

    constructor() {
        super({
            key: "MainScene"
        });
    }

    preload(): void {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;

        // All preloaded assets will be stored in the texture manager by the given key
        this.load.image("pixel", require("/src/assets/qci/sprites/pixel.png"));
        this.load.tilemapTiledJSON('map', require("/src/assets/qci/maps/grade_5_landscaping_1.json"));
        this.load.image("astronaut", require("/src/assets/qci/sprites/astronaut.png"));
        this.load.atlas("assets", require("src/assets/qci/atlas/gameLandscape.png"), require("src/assets/qci/atlas/gameLandscape.json"));
    }

    create(): void {
        this.initialize();
        this.generateScene();
        this.generateEvents();
        this.generateDropZones();
        this.generateDraggables();
        this.updateScoreboard();
    }

    initialize() {
        this.map = this.make.tilemap({ key: 'map' });

        this.scores.push({ id: "trees", display: "Trees to place", score: 3 });
        this.scores.push({ id: "bushes", display: "Shrubs to place", score: 10 });
        this.scores.push({ id: "fountains", display: "Fountain to place", score: 1 });
        this.scores.push({ id: "satellites", display: "Satellite dish to place", score: 1 });

        this.bubbleText = this.add.text(this.gameWidth - 230, this.gameHeight - 300, "");
        this.bubbleText.setOrigin(0);
        this.bubbleText.setDepth(2);
        this.bubbleText.setFontFamily("Arial");
        this.bubbleText.setFontSize(20);
        this.bubbleText.setPadding(20,20,20,20);
        this.bubbleText.setColor('#000000');
        this.bubbleText.setWordWrapWidth(150);
        this.bubbleText.setBackgroundColor('#ffffff');
    }

    generateScene() {
        // Red Background
        this.background = this.add.image(0, 0, "pixel");
        this.background.setOrigin(0);
        this.background.setDepth(0);
        this.background.setTint(0xef4a4d);
        this.background.setDisplaySize(this.gameWidth, this.gameHeight);
        Phaser.Display.Align.In.Center(this.background, this.add.zone(8, 8, this.gameWidth, this.gameHeight));

        var sceneLayer = this.map.getObjectLayer('Scene');

        var fontStyle1 = { fontSize: 16, color: '#ffffff', align: 'right' };
        var fontStyle2 = { fontSize: 16, color: '#ffffff' };

        // Generate Objects
        sceneLayer.objects.forEach((ob: TiledGameObject) => {
            if (ob.type !== "") {
                console.warn("Unknown Type Detected", ob.type);
                return;
            }
            var tileName: string = ob.name.toLowerCase();

            if (tileName === "house") {
                let house = this.add.image(ob.x, ob.y, "assets", "house");
                house.setOrigin(0);
                house.setDepth(2);
                house.setDisplaySize(ob.width, ob.height);
            } else if (tileName === "path") {
                let path = this.add.image(ob.x, ob.y, "assets", "path");
                path.setOrigin(0);
                path.setDepth(1);
                path.setDisplaySize(ob.width, ob.height);
            } else if (tileName === "garage") {
                let garage = this.add.image(ob.x, ob.y, "assets", "garage");
                garage.setOrigin(0);
                garage.setDepth(2);
                garage.setDisplaySize(ob.width, ob.height);
            } else if (tileName === "scoreboard") {
                let scoreboard = this.add.image(ob.x, ob.y, "pixel");
                scoreboard.setOrigin(0);
                scoreboard.setDepth(0);
                scoreboard.setTint(0x157CAD);
                scoreboard.setDisplaySize(ob.width, ob.height);
            } else if (tileName === "blueprint") {
                let blueprint = this.add.image(ob.x, ob.y, "assets", "blueprint");
                blueprint.setOrigin(0);
                blueprint.setDepth(1);
                blueprint.setTint(0xffffff);
                blueprint.setDisplaySize(ob.width + 10, ob.height + 10);
            } else if (tileName === "score_1") {
                let txt = this.add.text(ob.x, ob.y, "", fontStyle1);
                txt.setName(tileName);
                txt.setOrigin(0);
                txt.setFontFamily("Arial");
                txt.setDepth(1);
                txt.setStroke('#ffffff', .5);
                this.scoreTiles.push(txt);
            } else if (tileName === "score_2") {
                let txt = this.add.text(ob.x, ob.y, "", fontStyle2);
                txt.setName(tileName);
                txt.setOrigin(0);
                txt.setDepth(1);
                txt.setFontFamily("Arial");
                this.scoreTiles.push(txt);
            } else if (tileName === "exit") {
                let exitButton = this.add.image(ob.x, ob.y, "pixel");
                exitButton.setOrigin(0);
                exitButton.setDepth(1);
                exitButton.setInteractive();
                exitButton.setTint(0x157CAD);
                exitButton.setDisplaySize(ob.width, ob.height);
                exitButton.on("pointerdown", () => {
                    document[this.sys.game.device.fullscreen.cancel]();
                });
            } else if (tileName === "exittext") {
                let exitText = this.add.text(ob.x + 10, ob.y, "Exit");
                exitText.setOrigin(0);
                exitText.setDepth(1);
                exitText.setInteractive();
                exitText.setFontFamily("Arial");
                exitText.setFontSize(30);
                exitText.on("pointerdown", () => {
                    document[this.sys.game.device.fullscreen.cancel]();
                });
            } else if (tileName === "astronaut") {
                let astronaut = this.add.image(ob.x, ob.y, "astronaut");
                astronaut.setOrigin(0);
                astronaut.setDepth(1);
                astronaut.setDisplaySize(ob.width, ob.height);
            }
        });
    }

    generateEvents() {
        // Wire up events
        this.input.on('dragstart', (pointer: Phaser.Input.Pointer, gameObject: PhaserGeneralGameObjectType) => {
            gameObject.x = pointer.downX;
            gameObject.y = pointer.downY;
            gameObject.setAngle();
            this.children.bringToTop(gameObject);
        });

        this.input.on('drag', (pointer: Phaser.Input.Pointer, gameObject: PhaserGeneralGameObjectType, dragX: number, dragY: number) => {
            gameObject.x = pointer.x;
            gameObject.y = pointer.y;
        });

        this.input.on('dragend', (pointer: Phaser.Input.Pointer, gameObject: PhaserGeneralGameObjectType, dropped: boolean) => {
            // Move dropped object if not dropped onto a dropzone
            if (!dropped) {
                // Change feedback text to let them know they aren't dropping on a dropzone
                this.setSpeechBubbleText("Oops, try a drop zone!");
                gameObject.x = gameObject.input.dragStartX;
                gameObject.y = gameObject.input.dragStartY;
            }
            this.children.moveDown(gameObject);
        });
    }

    generateDropZones() {
        // Generate DZs
        var objectLayer = this.map.getObjectLayer('DropZones');
        objectLayer.objects.forEach((ob: TiledDropZone) => {
            if (ob.type !== "DropZone") {
                console.warn("Unknown Type Detected", ob.type);
                return;
            }

            // Merge config with properties, adjusting for accepted keys which is a comma delimited string
            var config: DropZoneConfig = {
                //...ob.properties,
                height: ob.height,
                width: ob.width,
                square: ob.square,
                // Optional arguments for when we want an image rather than plain circle dropzones
                backgroundTexture: "assets",
                backgroundFrame: "hotspot",
                ellipse: ob.ellipse,
                lineColor: this.rgbaHexToNumber(ob.properties.lineColor),
                dragLineColor: 0x83d86c,
                acceptedKeys: (ob.properties.acceptedKeys || "").split(',')
            };
            var dropZone = new DropZone(this, ob.x + ob.width / 2, ob.y + ob.height / 2, config);
            dropZone.on('drop', (dropzone: DropZone, gameObject: DropZoneType, accepted: boolean) => {
                var fontStyle2 = { fontSize: 16, color: '#ffffff' };
                if (accepted) {
                    // Choose a random good feedback to say
                    let good = ["Good Job!", "Nice!", "Perfect!", "Great Job!"];
                    this.setSpeechBubbleText(good[Math.floor(Math.random() * good.length)]);
                    this.scores.find(x => x.id === gameObject.name).score--;
                    this.updateScoreboard();
                }
                else {
                    // Choose a random bad feedback to say
                    let bad = ["Not Quite!", "Oops!", "That's okay!", "Try Again!"];
                    this.setSpeechBubbleText(bad[Math.floor(Math.random() * bad.length)]);
                    gameObject.x = gameObject.input.dragStartX;
                    gameObject.y = gameObject.input.dragStartY;
                }
            });
        });
    }

    // Show speech bubble and text (hide when click on something else)
    setSpeechBubbleText(text: string) {
        this.bubbleText.setText(text);
        this.input.on('pointerdown', () => {
            this.bubbleText.setText("");
        });
    }

    rgbaHexToNumber(color: string): number {
        if (color == null || color.length < 8) {
            return undefined;
        }
        return parseInt(color.substring(0, 8));
    }

    generateDraggables() {
        // Generate Plants
        var atlasTexture = this.textures.get('assets');
        var frames = atlasTexture.getFrameNames();
        var items = [
            {
                name: "trees", // Used in the scoring system
                keys: ["item", "tree"],
                x: 160,
                y: 120,
                height: 64,
                width: 64,
                texture: "assets",
                frame: "tree",
                count: this.scores.find(x => x.id === "trees").score
            },
            {
                name: "bushes", // Used in the scoring system
                keys: ["item", "bush"],
                x: 256,
                y: 120,
                height: 64,
                width: 64,
                texture: "assets",
                frame: "shrub",
                count: this.scores.find(x => x.id === "bushes").score
            },
            {
                name: "fountains", // Used in the scoring system
                keys: ["item", "fountain"],
                x: 352,
                y: 120,
                height: 64,
                width: 64,
                texture: "assets",
                frame: "fountain",
                count: this.scores.find(x => x.id === "fountains").score
            },
            {
                name: "satellites", // Used in the scoring system
                keys: ["item", "satellite"],
                x: 448,
                y: 120,
                height: 64,
                width: 64,
                texture: "assets",
                frame: "satellite",
                count: this.scores.find(x => x.id === "satellites").score
            }
        ];

        items.forEach(item => {
            for (let index = 0; index < item.count; index++) {
                let dropZoneSprite: DropZoneSprite = new DropZoneSprite(this, item.keys, item.x, item.y, item.texture, item.frame);
                dropZoneSprite.setDisplaySize(item.width, item.height);
                dropZoneSprite.setInteractive();
                dropZoneSprite.setName(item.name);
                this.input.setDraggable(dropZoneSprite);

            }
        });
    }

    updateScoreboard() {
        var numberTile = this.scoreTiles.find(x => x.name === "score_1");
        var textTile = this.scoreTiles.find(x => x.name === "score_2");

        var numbers: string[];
        var texts: string[];

        numberTile.setText([
            this.scores[0].score.toString(),
            "",
            this.scores[1].score.toString(),
            "",
            this.scores[2].score.toString(),
            "",
            this.scores[3].score.toString(),
            ""
        ]);
        textTile.setText([
            this.scores[0].display,
            "",
            this.scores[1].display,
            "",
            this.scores[2].display,
            "",
            this.scores[3].display,
            ""
        ]);

        // Game is done
        if (this.isDone()) {
            let finished = this.add.image(this.gameWidth / 2, this.gameHeight / 2, "pixel");
            finished.setDepth(4);
            finished.setTint(0x00000);
            finished.setDisplaySize(600, 200);
            let txt = 'Mission Complete!';
            let text = this.add.text(this.gameWidth / 2, this.gameHeight / 2, txt);
            text.setFontFamily('Arial');
            text.setFontSize(64);
            text.setDepth(4);
            text.setOrigin(.5);
            return;
        }
    }

    // Checks if all items have been dropped in their respective dragzones
    isDone(): boolean {
        for (var i = 0; i < this.scores.length; i++) {
            if (this.scores[i].score > 0) {
                return false;
            }
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/games/demos/LandscapingDemo/scenes/MainScene.ts